// extracted by mini-css-extract-plugin
module.exports = {"text":"PageTitle_text__2Jume"};